export default __webpack_public_path__ + "static/media/pencil.0adab3f4.svg";